import { render, staticRenderFns } from "./similarity-slider.vue?vue&type=template&id=0cd564df&scoped=true&"
import script from "./similarity-slider.vue?vue&type=script&lang=ts&"
export * from "./similarity-slider.vue?vue&type=script&lang=ts&"
import style0 from "./similarity-slider.vue?vue&type=style&index=0&id=0cd564df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd564df",
  null
  
)

export default component.exports